import {useNavigate, useParams} from 'react-router-dom'
import {HeaderTitle} from '../../../../../../common/HeaderTitle.jsx'
import ButtonWithIcon from '../../../../../../common/ButtonWithIcon.jsx'
import {Icons} from '../../../../../../common/Icons.jsx'
import Wizard from '../../../../../../common/wizard/Wizard.jsx'
import {
    DanePodstawowe,
    BudzetProjektu,
    Podsumowanie,
    Start,
    ZrodlaFinansowania,
    CelGlowny,
    SposobRealizacji,
    KamienieMilowe,
    Ryzyka,
    ZadaniaIT,
    Zalaczniki,
    OchronaDanych,
    Harmonogram,
    Powiazania,
} from './pages/index.js'
import {useSelector} from 'react-redux'
import {useZlozKarteProjektu} from "../../../../../../../api/domain/elementyRejstru/mutations/useZlozKarteProjektu.jsx";
import {CLEAR_KP} from "./clearing/clear_kp.js";

const ViewProjektForm = () => {
    const WIZARD_NAME = 'kp1'
    const {id, tryb} = useParams()
    const rola = useSelector((state) => state.user.role)
    const roleParam = rola === 'oper' ? 'oper/' : '/'
    const navigate = useNavigate()
    const clear_kp = new CLEAR_KP()

    const {mutate: zakonczEdycje} = useZlozKarteProjektu()

    const acceptButtons = () => {
        return (
            <ButtonWithIcon
                icon={<Icons.send/>}
                onClick={() => zakonczEdycje({id})}
                variant={'success'}
                text={'Zapisz i złóż'}
                className={'ms-0 p-2'}
            />
        )
    }

    return (
        <>
            <HeaderTitle
                home
                nav
                size={'fs-2'}
                breadcrumbLinks={[
                    {
                        label: 'Wszystkie projekty',
                        to: `/${rola}/rejestr/lista`,
                    },
                    {label: 'Wypełnij kartę projektu'},
                ]}
                data={[['ID', id]]}
                destination={`/${rola}/rejestr/lista`}
                title={'Wypełnij kartę projektu'}
            />
            <Wizard
                debug
                mode={tryb}
                name={WIZARD_NAME}
                dataUrl={`${roleParam}rejestr/${id}`}
                validationUrl={`${roleParam}rejestr/${id}/podsumowanie`}
                saveUrl={`${roleParam}rejestr`}
                mappingUrl={`${roleParam}rejestr/wzor/${WIZARD_NAME}`}
                acceptButtons={acceptButtons}
                saveOnPageChange={true}
                stateForPage={false}
                saveAndQuitCallback={() => navigate(`/${rola}/rejestr/lista`)}
                cancelCallback={() => navigate(`/${rola}/rejestr/lista`)}
                filterByCategory={true}
                projectCategory={'kategoria'}
                pages={[
                    {name: 'start', form: <Start/>},
                    {name: 'dane_podstawowe', form: <DanePodstawowe/>},
                    {name: 'budzet_projektu', form: <BudzetProjektu/>},
                    {name: 'finansowanie', form: <ZrodlaFinansowania/>},
                    {name: 'cel_projektu', form: <CelGlowny/>},
                    {name: 'realizacja', calc: (form) => clear_kp.dane(form), form: <SposobRealizacji/>},
                    {name: 'kamienie_milowe', form: <KamienieMilowe/>},
                    {name: 'harmonogram', form: <Harmonogram/>},
                    {name: 'powiazania', form: <Powiazania/>},
                    {name: 'ryzyka', form: <Ryzyka/>},
                    {name: 'zadania_it', calc: (form) => clear_kp.dane(form), form: <ZadaniaIT/>},
                    {name: 'ochrona_danych', calc: (form) => clear_kp.dane(form), form: <OchronaDanych/>},
                    {name: 'zalaczniki', form: <Zalaczniki/>},
                    {
                        page: 'podsumowanie',
                        name: 'podsumowanie',
                        form: <Podsumowanie/>,
                        summary: true,
                    },
                ]}
            />
        </>
    )
}

export default ViewProjektForm
